import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import {Card} from "./Card";

function MakeCard() {
  const [name, setName] = useState("");
  const [caption, setCaption] = useState("");
  const [logo, setLogo] = useState("");
  const [qrcode, setQrcode] = useState("");

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  return (
    <div className="d-flex flex-column align-items-center justify-content-center pt-5">
      <h1>Generate Smart Business Card</h1>
      <img
        src={require("../assets/urban-qr-code-1.png")}
        alt="intro-img failed to load"
      />
      <div className="mt-4">
        <label className="form-label">Business name</label>
        <input
          className="form-control"
          onChange={(e) => {
            setName(e.target.value);
          }}
        />

        <label className="form-label mt-3">Caption</label>
        <input
          className="form-control"
          placeholder="eg. dealers in the best..."
          onChange={(e) => {
            setCaption(e.target.value);
          }}
        />

        <label className="form-label mt-4">Generated QR Code</label>
        <input
          className="form-control"
          type="file"
          onChange={(e) => {
            setQrcode(URL.createObjectURL(e.target.files[0]));
          }}
        />

        <label className="form-label mt-3">
          Business logo <span>(Optional)</span>
        </label>
        <input
          className="form-control"
          type="file"
          onChange={(e) => {
            setLogo(URL.createObjectURL(e.target.files[0]));
          }}
        />
      </div>
      <Card Logo={logo} Qrcode={qrcode} Caption={caption} Name={name} ref={componentRef}/>

      <button className="btn btn-outline-primary" onClick={handlePrint}>Print Card</button>
    </div>
  );
}

export default MakeCard;
